import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Activity, Trophy, Calendar, User, ListOrdered } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { CompetitionListView } from './CompetitionListView';
import { ClassificationListView } from './ClassificationListView';
import { MatchFeedTab } from './MatchFeedTab';
import { MyDashboardTab } from './MyDashboardTab';

export const CompetitionsHub = () => {
  const [activeTab, setActiveTab] = useState<'FEED' | 'CLASSIFICACAO' | 'RANKINGS' | 'ETAPAS' | 'MEU_PAINEL'>('FEED');
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  return (
    <div className="rt-container">
      <div className="rt-card" style={{ padding: '32px' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <button onClick={() => navigate(-1)} style={{ background: 'var(--bg-panel)', border: 'none', width: '48px', height: '48px', borderRadius: '50%', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} title="Voltar">
            <ArrowLeft size={24} />
          </button>
          <div>
            <h1 style={{ color: 'white', fontSize: '28px', margin: 0 }}>Competições</h1>
            <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, marginTop: '4px' }}>Acompanhe classificações, torneios e partidas</p>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '32px', flexWrap: 'wrap', paddingBottom: '8px' }}>
          <button 
            onClick={() => setActiveTab('FEED')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '12px', border: 'none', background: activeTab === 'FEED' ? 'var(--primary-color)' : 'rgba(255,255,255,0.05)', color: activeTab === 'FEED' ? '#111827' : 'white', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
          >
            <Activity size={18} /> Feed Geral
          </button>
          <button 
            onClick={() => setActiveTab('CLASSIFICACAO')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '12px', border: 'none', background: activeTab === 'CLASSIFICACAO' ? 'var(--primary-color)' : 'rgba(255,255,255,0.05)', color: activeTab === 'CLASSIFICACAO' ? '#111827' : 'white', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
          >
            <Trophy size={18} /> Classificação Geral
          </button>
          <button 
            onClick={() => setActiveTab('RANKINGS')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '12px', border: 'none', background: activeTab === 'RANKINGS' ? 'var(--primary-color)' : 'rgba(255,255,255,0.05)', color: activeTab === 'RANKINGS' ? '#111827' : 'white', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
          >
            <ListOrdered size={18} /> Rankings
          </button>
          <button 
            onClick={() => setActiveTab('ETAPAS')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '12px', border: 'none', background: activeTab === 'ETAPAS' ? 'var(--primary-color)' : 'rgba(255,255,255,0.05)', color: activeTab === 'ETAPAS' ? '#111827' : 'white', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
          >
            <Calendar size={18} /> Torneios
          </button>
          <button 
            onClick={() => setActiveTab('MEU_PAINEL')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '12px', border: 'none', background: activeTab === 'MEU_PAINEL' ? 'var(--primary-color)' : 'rgba(255,255,255,0.05)', color: activeTab === 'MEU_PAINEL' ? '#111827' : 'white', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
          >
            <User size={18} /> Meu Painel
          </button>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: 'auto', paddingRight: '8px' }}>
          {activeTab === 'FEED' && (
             <div style={{ color: 'white' }}>
               <MatchFeedTab competitionId="" currentUser={currentUser} />
             </div>
          )}
          
          {activeTab === 'CLASSIFICACAO' && (
            <ClassificationListView />
          )}

          {activeTab === 'RANKINGS' && (
            <CompetitionListView type="RANKING" />
          )}

          {activeTab === 'ETAPAS' && (
            <CompetitionListView type="TOURNAMENT" />
          )}

          {activeTab === 'MEU_PAINEL' && (
             <MyDashboardTab />
          )}
        </div>
      </div>
    </div>
  );
};
